<template>
  <v-container class="grey lighten-5 mx-0 my-3 px-0 py-0">
    <v-card dense :loading="loading">
      <v-card-title class="mx-0 mt-0 mb-2 px-0 pb-0 pt-1 border-top-purple">
        <v-spacer></v-spacer>
              <v-icon color="primary" class="mx-1"  v-if="course.isFeatured">mdi-star-box-outline</v-icon>
              <Link :href="baseurl+'/course/'+course.alias">
                <v-icon style="margin-right:3px" color="teal">mdi-eye</v-icon>
              </Link>
              <v-icon v-if="!course.isFavorite" @click="triggerAddFavorite()" class="mx-1" color="primary">mdi-heart-outline</v-icon>
              <v-icon v-if="course.isFavorite" @click="triggerDelFavorite()" class="mx-1" color="primary">mdi-heart</v-icon>
      </v-card-title>
          <v-card-text class="hidden-md-and-down">
            <v-container class="mx-0 my-0 px-0 py-0">
              <v-row>
                <v-col cols=12 lg="12" class="d-flex justify-center align-center mx-0 my-0 px-0 py-0">
                
                    <v-img 
                    v-if="course.organization.photo_path"
                    max-height="100"
                    max-width="175"
                    contain
                      :src="baseurl + '/img/'+course.organization.photo_path">
                    </v-img>
                </v-col>
              </v-row>
              <v-row>
                <v-col><Link :href="baseurl+'/course/'+course.alias"><span class="text-body-1"  style="color:rgb(66,66,66) !important">{{course.title}}</span></Link></v-col>
              </v-row>
              <v-row>
                <v-col cols="12" lg="12" class="">
                  <span><v-icon class="mr-3">mdi-shape</v-icon>{{course.category.title}}</span>
                </v-col>
              </v-row>
                <v-row>
                  <v-col cols="12" sm="12" lg="6" md="6" v-if="course.region">
                      <span><v-icon class="mr-3">mdi-map</v-icon>{{course.region}}</span>
                  </v-col>
                  <v-col cols="12" sm="12" lg="6" md="6" v-if="course.awarding_body">
                    <span><v-icon class="mr-3">mdi-license</v-icon><span v-html="course.awarding_body"></span></span>
                  </v-col>
                  <v-col cols="12" sm="12" lg="6" md="6" v-if="course.duration">
                    <span><v-icon class="mr-3">mdi-clock</v-icon><span v-html="course.duration"></span></span>
                  </v-col>
                </v-row>
                
                
            </v-container>
          </v-card-text>
          

    </v-card>   
  </v-container>
</template>
<script>
import { Head } from '@inertiajs/inertia-vue'
import Layout from '@/Shared/VuetifyLayout'
import axios from 'axios'

import { Link } from '@inertiajs/inertia-vue'

export default {
  props: {
    course: Object,
    auth: Object,
    state: String,
    baseurl: String,
    prevurl: String,
  },
  components: {
    Head,
    Link
  },
  layout: Layout,
  data() {
      return {
          applyDialog: false,
          loading: false,
      }
  },
  watch: {
  },
  created() {
  },
  methods: {  
    getUrl() {
        return 'https://www.google.com/maps/search/?api=1&query='+encodeURIComponent(this.course.address +','+this.course.region)

    },
    canApply() {
      if (!this.auth.user || (this.auth.user.roles.includes('admin') || this.auth.user.roles.includes('user')))
          return true;
      else
          return false;
    },
    triggerApply() {
      console.log('trigger apply');
      if (!this.auth.user)
          this.$emit('toggleComponentLogin','courseapply-'+this.course.id);
      else if (this.course.course_link)
          window.open(window.location + '/apply')
      else
          this.applyDialog = true;
          
    },
    triggerAddFavorite() {
      this.loading=true;
      console.log('trigger addfavorite');
      let vm = this;
      if (!this.auth.user)
          this.$emit('toggleComponentLogin','courseaddfavorite-'+this.course.id);
      else
          this.$inertia.get(this.baseurl+"/user/course/addfavorite/"+this.course.id,{},{
            preserveState: true,
            preserveScroll: true,
            onFinish: visit => {
              // This won't be called until doThing()
              // and doAnotherThing() have finished.
              vm.loading = false;
            },
          })
    },
    triggerDelFavorite() {
      this.loading = true;
      let vm = this;
      console.log('trigger delfavorite',this.auth.user,this.baseurl+"/user/course/delfavorite/"+this.course.id);
      if (!this.auth.user)
        this.$emit('toggleComponentLogin','coursedelfavorite-'+this.course.id);
      else
          this.$inertia.get(this.baseurl+"/user/course/delfavorite/"+this.course.id,{},{
            preserveState: true,
            preserveScroll: true,
            onFinish: visit => {
              vm.$emit('refresh');
              // This won't be called until doThing()
              // and doAnotherThing() have finished.
              vm.loading = false;
            },
          });
    }
  },
}
</script>

<style>
  .fixedFooter {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  color: white;
  text-align: center;
  }
  </style>